export enum ControlTowerContext {
  /** GPX Portal - Client-facing view with limited columns and features */
  GPX = "GPX",
  /** Canopy/Fund Admin Frontend - Internal FA/IS view with full features */
  CANOPY = "CANOPY",
}
